module.exports = __webpack_public_path__ + "media/images/new-ui-images/detail-icon-5dded985de1cdb8747a44753b6f8de64.svg";